import { FiAlertCircle } from 'react-icons/fi';

interface FormErrorProps {
  errors: string;
}

export default function FormError({ errors }: FormErrorProps) {
  return (
    <div className="flex items-center gap-2 text-sm text-error">
      <FiAlertCircle />
      <span>{errors}</span>
    </div>
  );
}
